// third-party
import { FormattedMessage } from "react-intl";

// assets
import { IconClipboardCheck, IconTarget, IconAd, IconPhoto, IconList, IconLanguage, IconTag, IconSettings } from '@tabler/icons';

const other = {
    id: 'sample-docs-menu',
    type: 'group',
    children: [
        {
            id: "Category",
            title: "Categories",
            type: "collapse",
            // url: "/raffle-categories",
            icon: IconList,
            breadcrumbs: false,
            children: [
                {
                    id: 'menu-category',
                    title: 'Menu Categories',
                    type: "item",
                    url: '/menu-category'
                },
                {
                    id: 'restaurant-category',
                    title: 'Restaurant Categories',
                    type: "item",
                    url: '/restaurant-category'
                },
            ]
        },

        // {
        //     id: "site-settings",
        //     title: <FormattedMessage id="Settings" />,
        //     type: "collapse",
        //     icon: IconSettings,
        //     breadcrumbs: false,
        //     children: [
        //         {
        //             id: 'Setting-level-1',
        //             title: (
        //                 <>
        //                     <FormattedMessage id="Setting" />
        //                 </>
        //             ),
        //             type: "item",
        //             url: "/setting",
        //         },
        //         {
        //             id: 'CMS-level-3',
        //             title: (
        //                 <>
        //                     <FormattedMessage id="CMS" />
        //                 </>
        //             ),
        //             url: '/cms',
        //             type: 'item'
        //         }
        //     ]
        // },
    ]
}

export default other